import React from "react";

//Icons
import DeleteIcon from "react-icons/lib/md/delete";

import ToolTipItem from "../utils/tooltip";
import { Table, Th, Thead, Tr, Td } from "reactable";
import ServerPaginatedTable from "../utils/pagination.server";

const FTPCredentialsTableStructure = ({
  data,
  deleteCallback,
  interpreteAirlines
}) => (
  <div>
    <Table
      className="table table-striped table-hover"
      id="table"
      sortable={true}
      // itemsPerPage={10}
      // pageButtonLimit={10}
    >
      <Thead>
        <Th column="Airline">
          <span>Airline</span>
        </Th>
        <Th column="Username">
          <span>Username</span>
        </Th>
        <Th column="ServerAddress">
          <span>Server Address</span>
        </Th>
        {/* <Th column="EmailAddress">
                        <span>Email Address</span>
                    </Th> */}
        <Th column="Action">
          <span>Action</span>
        </Th>
      </Thead>

      {data.map((item, i) => (
        <Tr key={i}>
          <Td column="Airline" className="text-capitalize">
            {interpreteAirlines(item.AirlineCode)}
          </Td>
          <Td column="Username">{item.Username}</Td>
          <Td column="ServerAddress" className="text-capitalize">
            {item.ServerAddress}
          </Td>
          <Td column="EmailAddress" className="text-capitalize">
            {item.EmailAddress}
          </Td>
          <Td column="Action">
            <span
              className="text-primary pointer"
              onClick={e => deleteCallback(item)}
            >
              <ToolTipItem
                key={i + "delete"}
                title={<DeleteIcon size="15" color="#ff1f1f" />}
                content="Delete record"
                id={i + "delete"}
              />
            </span>
          </Td>
        </Tr>
      ))}
    </Table>
  </div>
);

class FTPCredentialsTable extends React.Component {
  render() {
    let {
      data,
      deleteCallback,
      pageSize,
      currentPage,
      totalCredentialCount,
      pageDataCallback,
      interpreteAirlines
    } = this.props;

    return (
      <div>
        <ServerPaginatedTable
          currentPage={currentPage}
          fetchMore={pageDataCallback}
          target={
            <FTPCredentialsTableStructure
              interpreteAirlines={interpreteAirlines}
              deleteCallback={deleteCallback}
              data={data}
            />
          }
          pageSize={pageSize}
          totalCount={totalCredentialCount}
        />
      </div>
    );
  }
}
export default FTPCredentialsTable;



// WEBPACK FOOTER //
// ./src/views/ftp-credentials/ftp-credentials-table.js